import React from 'react';
import ContentLoader from 'react-content-loader';

const DepartmentEditLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={1463}
      height={375}
      viewBox="0 0 1463 375"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebed">
      <>
        <rect x="28" y="24" rx="3" ry="3" width="280" height="22" />
        <rect x="28" y="74" rx="3" ry="3" width="89" height="30" />
        <rect x="132" y="74" rx="3" ry="3" width="89" height="30" />
        <rect x="28" y="116" rx="3" ry="3" width="119" height="30" />
        <rect x="155" y="116" rx="3" ry="3" width="119" height="30" />
        <rect x="285" y="116" rx="3" ry="3" width="119" height="30" />
        <rect x="28" y="196" rx="3" ry="3" width="19" height="18" />
        <rect x="28" y="241" rx="3" ry="3" width="19" height="18" />
        <rect x="58" y="236" rx="3" ry="3" width="1280" height="31" />
        <rect x="1230" y="23" rx="3" ry="3" width="166" height="30" />
        <rect x="1230" y="122" rx="3" ry="3" width="19" height="18" />
        <rect x="1255" y="122" rx="3" ry="3" width="137" height="18" />
        <rect x="58" y="196" rx="3" ry="3" width="137" height="18" />
      </>
    </ContentLoader>
  );
};

export default DepartmentEditLoader;
